import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PaninfoPage } from './paninfo.page';

const routes: Routes = [
  {
    path: '',
    component: PaninfoPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaninfoPageRoutingModule {}
